/**
 * Unions API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Мероприятие с решением участника.
 */
export interface EventView { 
    /**
     * Идентификатор создателя.
     */
    createdBy?: string;
    /**
     * Дата начала.
     */
    dateStart?: string;
    /**
     * Дата окончания.
     */
    dateEnd?: string;
    /**
     * адрес
     */
    address?: string;
    /**
     * Лицо для связи (telegramId).
     */
    contactPerson?: number;
    /**
     * Тема.
     */
    subject?: string;
    /**
     * Описание.
     */
    description?: string;
    /**
     * Ссылка на документы.
     */
    docsLink?: string;
    /**
     * Статус.
     */
    status?: number;
    /**
     * Мероприятие верхнего уровня.
     */
    parentId?: string;
    /**
     * Идентификатор организации, создавшей мероприятие.
     */
    organisationId?: string;
    /**
     * Ссылка на online-трансляцию.
     */
    onlineLink?: string;
    /**
     * Идентификатор бота.
     */
    botId?: number;
    /**
     * Идентификатор канала.
     */
    channelId?: number;
    /**
     * Идентификатор типа мероприятия.
     */
    eventTypeId?: number;
    /**
     * Признак видимости мероприятия всем.
     */
    isVisibleToAll?: boolean;
    /**
     * Признак доступного всем мероприятия.
     */
    isFreeToRegister?: boolean;
    /**
     * ID комитета.
     */
    committeeId?: string;
    /**
     * Лицо для связи (внутренний ID).
     * @deprecated
     */
    contactPersonId?: string;
    /**
     * Временная зона клиента 5 символов. Например \"+0500\"
     */
    localTimezone?: string;
    /**
     * Идентификатор мероприятия
     */
    id: string;
    /**
     * Идентификатор решения.
     */
    decisionTypeCode?: number;
    /**
     * Решение.
     */
    decisionTypeName?: string;
    /**
     * Тип мероприятия.
     */
    eventType?: string;
    /**
     * ID фотографии мероприятия.
     */
    photoId?: string;
    /**
     * Идентификатор группы.
     */
    groupChatId?: number;
    /**
     * Invite в групповой чат.
     */
    groupInviteCode?: string;
}

